import { SomeEntity } from '~/clients/api-guards'

export type EntityId = number
export type EntityUuid = string

export type EntityTable<T> = {
    byId: Record<EntityId, T>
    allIds: EntityId[]
    byUuid: Record<EntityUuid, T>
    allUuids: EntityUuid[]
} & Record<string, unknown>

export function createEntityState<T>(): EntityTable<T & { isOptimistic?: true }> {
    return {
        byId: {},
        allIds: [],
        byUuid: {},
        allUuids: [],
    }
}

export type EntityGuard<T extends SomeEntity = SomeEntity> = (entity: SomeEntity) => entity is T
